const FORBIDDEN_TAGS = ["script", "style", "iframe", "object", "embed", "link", "meta", "base", "form", "input", "button"];
const FORBIDDEN_ATTR_RE = /^on/i;
// eslint-disable-next-line no-script-url
const FORBIDDEN_URL_SCHEMES = ["javascript:", "vbscript:", "data:", "file:"];

export const sanitizeHtml = (value) => {
  const raw = String(value ?? "");
  if (!raw) return "";
  try {
    const doc = new DOMParser().parseFromString(raw, "text/html");
    FORBIDDEN_TAGS.forEach((tag) => {
      doc.querySelectorAll(tag).forEach((node) => node.remove());
    });
    doc.querySelectorAll("*").forEach((node) => {
      Array.from(node.attributes).forEach((attr) => {
        const name = attr.name;
        const val = String(attr.value || "").trim().toLowerCase();
        if (FORBIDDEN_ATTR_RE.test(name)) {
          node.removeAttribute(name);
          return;
        }
        if ((name === "href" || name === "src" || name === "xlink:href") && FORBIDDEN_URL_SCHEMES.some((s) => val.startsWith(s))) {
          node.removeAttribute(name);
        }
      });
    });
    return doc.body.innerHTML || "";
  } catch {
    return "";
  }
};

export const sanitizeRelativeUrl = (url) => {
  const raw = String(url ?? "").trim();
  if (!raw) return "";
  if (/[\s]/.test(raw)) return "";
  if (raw.includes(":")) return "";
  if (raw.startsWith("//") || raw.startsWith("/\\") || raw.startsWith("\\")) return "";
  return raw.replace(/^\/+/, "");
};